import axios from 'axios'
import AwsConfig from '../../Config/AwsConfig'

function mergePersons(input) {
  const data = JSON.stringify(input)

  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: AwsConfig.MergePersons,
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  }

  return axios.request(config)
}

export default mergePersons
